module.exports = __webpack_public_path__ + "static/poir-197fbe74a0075e3bf6b196739737fc56.png";